import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IconComponent } from '../../common/icon/icon.component';
import { RtUICoreOverlayModule } from './../../core/core.module';
import { TimeZonePickerComponent } from './time-zone-picker.component';

@NgModule({
  exports: [TimeZonePickerComponent],
  imports: [RtUICoreOverlayModule, CommonModule, IconComponent, TimeZonePickerComponent],
})
export class TimeZonePickerModule {}
export { TimeZonePickerComponent } from './time-zone-picker.component';
